<template>
  <!-- style="height: 100vh; width: 100vw" -->
    <router-view/>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
  components: {
  },
  setup (props, context) {
  }
})
</script>
